<template>
    <c-contract-editor
        :title    = "$t('contract.zus.fulltitle')"
        :unit-data = "unitData"
        @store    = "onStore"
        @edit     = "onEdit"
        @start    = "onStart"
        @end      = "onEnde"
    >
         <template v-slot:additional>
            <v-row class="no-frame">
                <v-col class="no-frame pr-1 col-6">
                    <f-currency-field-rw
                        :label        = "$t('contract.zus.costsMainAudit')"
                        :readonly     = "readonly"
                        v-model       = "unitData.mainAudit"
                        :hide-details = "true"
                    />
                </v-col>
                <v-col class="no-frame pl-1">
                    <f-currency-field-rw
                        :label        = "$t('contract.zus.costIntermediateAudit')"
                        :readonly     = "readonly"
                        v-model       = "unitData.intermediateAudit"
                        :hide-details = "true"
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame">
                <v-col class="no-frame pr-1">
                    <f-currency-field-rw
                        :label        = "$t('contract.zus.costAuditAfterChange')"
                        :readonly     = "readonly"
                        v-model       = "unitData.auditAfterChange"
                        :hide-details = "true"
                    />
                </v-col>
                <v-col class="no-frame pl-1">
                    <f-currency-field-rw
                        :label        = "$t('contract.zus.costAuditAfterDefects')"
                        :readonly     = "readonly"
                        v-model       = "unitData.auditAfterDefects"
                        :hide-details = "true"
                    />
                </v-col>
            </v-row>
        </template>
     </c-contract-editor>
</template>

<script>

import CContractEditor  from "@/modules/msd/company/contract/components/controls/CContractEditor.vue";
import FCurrencyFieldRw from "@/modules/core/components/utils/FCurrencyFieldRw.vue";
import Contract from "@/modules/msd/company/contract/service/Contract";
import Core from "@/modules/core/service/Core";

export default {
    name: "CContractZusEditor",

    components: {
        FCurrencyFieldRw,
        CContractEditor,
    },

    props: {
        unit: {
            default: function () {
                return {
                    contractZusStart    : null,
                    zusMainAudit        : null,
                    zusIntermediateAudit: null,
                    zusAfterChangeAudit : null,
                    zusAfterDefectAudit : null,
                }
            }
        }
    },


    data: () => ({
        readonly: true,
        unitData: {
            start            : null,
            mainAudit        : null,
            intermediateAudit: null,
            auditAfterChange : null,
            auditAfterDefects: null,
        }
    }),

    mounted() {
        this.setData();
    },

    watch: {
        unit () {
            this.setData();
        }
    },

    methods: {
        onStore () {
            Contract.unit.saveZus(this.unit.id, this.unit.contractZusId, this.unitData).then(() => {
                this.unit.contractZusStart     = this.unitData.start;
                this.unit.zusMainAudit         = this.unitData.mainAudit;
                this.unit.zusIntermediateAudit = this.unitData.intermediateAudit;
                this.unit.zusAfterChangeAudit  = this.unitData.auditAfterChange;
                this.unit.zusAfterDefectAudit  = this.unitData.auditAfterDefects;
                Core.message.hint(this, this.$t('contract.edit.stored'));
            });
        },

        onEdit (readonly) {
            this.readonly = readonly;
        },

        onStart (value) {
            this.unitData.start = value;
        },

        onEnde (value) {
            this.unitData.end = value;
        },

        setData () {
            this.unitData.start             = this.unit.contractZusStart;
            this.unitData.end               = this.unit.contractZusExpiration
            this.unitData.mainAudit         = this.unit.zusMainAudit;
            this.unitData.intermediateAudit = this.unit.zusIntermediateAudit;
            this.unitData.auditAfterChange  = this.unit.zusAfterChangeAudit;
            this.unitData.auditAfterDefects = this.unit.zusAfterDefectAudit;
        },
    }
}
</script>

<style scoped>

</style>